export const useDefaultSortingSettings = <T extends { enableSorting?: boolean; sortDescFirst?: boolean }>(
  list: T[],
) => {
  for (const item of list) {
    if (item.enableSorting === undefined) {
      item.enableSorting = false;
    }

    if (item.sortDescFirst === undefined) {
      item.sortDescFirst = true;
    }
  }

  return list;
};
